import { render } from "./BasePhoneButton.vue?vue&type=template&id=4b9b6fd8&scoped=true"
import script from "./BasePhoneButton.vue?vue&type=script&lang=js"
export * from "./BasePhoneButton.vue?vue&type=script&lang=js"

import "./BasePhoneButton.vue?vue&type=style&index=0&id=4b9b6fd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9b6fd8"]])

export default __exports__